import React, { useEffect, useState } from 'react';
export const CountdownTimer = () => {
  // Start at 23:59:17 as requested
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 17
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex flex-col items-center justify-center py-2 md:py-8" data-id="element-81">
      <div className="text-gold-500 font-bold uppercase tracking-widest mb-2 md:mb-4 text-[11px] md:text-base flex items-center gap-2 text-center" data-id="element-82">
        <span data-id="element-83">⏳</span> El precio de lanzamiento termina en:
      </div>

      <div className="flex items-center gap-1.5 md:gap-4 text-2xl md:text-6xl font-bebas text-white mb-2 md:mb-6" data-id="element-84">
        <div className="bg-navy-800 border border-navy-700 rounded-lg px-2.5 md:px-4 py-1 md:py-2 min-w-[56px] md:min-w-[80px] text-center" data-id="element-85">
          {format(timeLeft.hours)}
          <div className="text-[9px] md:text-xs text-gray-400 font-inter tracking-normal mt-0.5 md:mt-1 uppercase" data-id="element-86">
            Horas
          </div>
        </div>
        <span className="text-gold-500 pb-3 md:pb-6" data-id="element-87">:</span>
        <div className="bg-navy-800 border border-navy-700 rounded-lg px-2.5 md:px-4 py-1 md:py-2 min-w-[56px] md:min-w-[80px] text-center" data-id="element-88">
          {format(timeLeft.minutes)}
          <div className="text-[9px] md:text-xs text-gray-400 font-inter tracking-normal mt-0.5 md:mt-1 uppercase" data-id="element-89">
            Min
          </div>
        </div>
        <span className="text-gold-500 pb-3 md:pb-6" data-id="element-90">:</span>
        <div className="bg-navy-800 border border-navy-700 rounded-lg px-2.5 md:px-4 py-1 md:py-2 min-w-[56px] md:min-w-[80px] text-center" data-id="element-91">
          {format(timeLeft.seconds)}
          <div className="text-[9px] md:text-xs text-gray-400 font-inter tracking-normal mt-0.5 md:mt-1 uppercase" data-id="element-92">
            Seg
          </div>
        </div>
      </div>

      <div className="w-full max-w-md bg-navy-800 rounded-full h-2 md:h-4 mb-1.5 md:mb-2 border border-navy-700 overflow-hidden relative" data-id="element-93">
        <div className="absolute top-0 left-0 h-full bg-gradient-to-r from-red-600 to-red-500 w-[68%] rounded-full" data-id="element-94" />
      </div>
      <div className="text-red-400 font-bold flex items-center gap-1.5 text-[11px] md:text-base" data-id="element-95">
        <span data-id="element-96">🔥</span> 68% tomados — sube $8.000 después
      </div>
    </div>;
};